export class UsersForRoleCodeRequest {
  relatedStoreId?: number;
  roleCode?: string;
  allowedType?: string;
}
